import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning",
  "use": "warning-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"warning\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FC0\" cx=\"8\" cy=\"8\" r=\"8\" /><path fill=\"#FFF\" d=\"M6.857 10.667h2.286v2.286H6.857zM6.6 3.048H9.47l-.328 6.857H6.857z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id